import { HttpService } from "../../../utils/DesigningHttpService.js";
import { agencyBootstrap, type AgencyChoice } from "./agencyIdentityService.ts";

const http = new HttpService();

export async function readAgencyMemberships(): Promise<AgencyChoice[]> {
  return (await http.getasync("/catalog/agency-memberships")).data;
}

export async function selectAgencyMembership(membershipId: number): Promise<void> {
  const bootstrap = await agencyBootstrap();
  await http.postasync("/catalog/agency-memberships", { membershipId }, {
    headers: { "X-Portal-Csrf": bootstrap.csrfToken },
  });
}
